<template>
  <form>
    <div class="columns">
      <div class="column">
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label"></label>
          </div>
          <div class="field-body">
            <div class="field">
              <h3 class="title is-3">Edit game</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <game-configuration
      ref="game_configuration"
      :disable-auto-locate="true"
      :isLoading="isLoading"
      @updated="onGameDetailsUpdated"
      @gameValidated="tryToUpdateGame"
    >
    </game-configuration>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label"></label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <div>
              <button @click.prevent="checkGameValidity" class="button is-primary">Update game</button>
              <button @click.prevent="cancelGameUpdate" class="button" style="margin-left: 5px;">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import gamesService from '../services/gamesService'
  import GameConfiguration from './single/GameConfiguration.vue'
  import {mapGameForDisplay} from '../helpers/game-helper'
  import dateUtils from '../helpers/date-helper'
  import displayHelper from '../helpers/display-helper'

  export default {
    name: 'EditGame',
    components: {
      GameConfiguration
    },
    created() {
      this.gameId = this.$route.params.id
      this.loadGameById(this.gameId)
    },
    data() {
      return {
        existingLogo: '',
        gameId: '',
        game: null,
        isLoading: false,
      }
    },
    methods: {
      onGameDetailsUpdated(game) {
        this.game = {
          gameLogo: game.gameLogo,
          autoStop: game.autoStop,
          gameName: game.gameName,
          gameDisplayedName: game.gameDisplayedName,
          gameDescription: game.gameDescription,
          gameLatitude: game.geo.lat,
          gameLongitude: game.geo.lng,
          createdAt: game.createdAt,
          questionRadius: game.questionRadius,
          gameZoom: game.geo.zoom,
          gameStartDate: dateUtils.mergeTimeToDate(game.startDate, game.startTime),
          gameEndDate: dateUtils.mergeTimeToDate(game.endDate, game.endTime),
        }
      },
      cancelGameUpdate() {
        this.$router.push({ name: 'Games' })
      },
      loadGameById(gameId) {
        const parent = this
        this.isLoading = true
        gamesService.getGameById(gameId)
          .then((game) => {
            this.existingLogo = game.imageUrl
            const transformedGame = mapGameForDisplay(game)
            this.$refs.game_configuration.preFillFields(transformedGame)
            this.$refs.game_configuration.setGeo(transformedGame.geo)
            this.$refs.game_configuration.injectLogoPreview(game.imageUrl)
            this.isLoading = false
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Oops, there was an error: ' + err.message)
            this.isLoading = false
          })
      },
      checkGameValidity() {
        this.$emit('tryToValidateGame', true)
      },
      tryToUpdateGame(validInput) {
        if (!validInput) {
          window.scrollTo(0, 0)
          return
        }
        const parent = this
        this.game.existingLogo = this.existingLogo
        this.isLoading = true
        gamesService.updateGame(this.game, this.gameId)
          .then(() => {
            this.isLoading = false
            this.$router.push({ name: 'Games' })
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Error while updating the game: ' + err.message)
            window.scrollTo(0, 0)
            this.isLoading = false
          })
      }
    }
  }
</script>

<style scoped>
  .field-label {
    flex-grow: 0;
  }
</style>
